const _allWindowsClosedState = {
    isAboutTimeTrackerOpen: false,
    isActivityCategoryOpen: false,
    isAddFavoritesOpen: false,
    isDateFilterPickerOpen: false,
    isEditFavoritesOpen: false,
    isLocationListOpen: false,
    isOpportunityListOpen: false,
    isProductGroupOpen: false,
    isReportErrorOpen: false,
    isServiceRequestOpen: false,
    isWorkingHoursOpen: false
};

const _initialState = {
    ..._allWindowsClosedState,
    locationsFrom: null,
    opportunitiesFor: null
};


export default function modalReducer(state = _initialState, action) {
    switch (action.type) {
    case "OPEN_EDIT_FAVORITES":
        return Object.assign({}, state, _allWindowsClosedState, {
            isEditFavoritesOpen: true
        });

    case "OPEN_ADD_FAVORITES":
        return Object.assign({}, state, _allWindowsClosedState, {
            isAddFavoritesOpen: true
        });

    case "OPEN_ACTIVITY_CATEGORY":
        return Object.assign({}, state, _allWindowsClosedState, {
            isActivityCategoryOpen: true
        });

    case "OPEN_PRODUCT_GROUP":
        return Object.assign({}, state, _allWindowsClosedState, {
            isProductGroupOpen: true
        });

    case "OPEN_SERVICE_REQUEST":
        return Object.assign({}, state, _allWindowsClosedState, {
            isServiceRequestOpen: true
        });

    case "OPEN_WORKING_HOURS":
        return Object.assign({}, state, _allWindowsClosedState, {
            isWorkingHoursOpen: true
        });

    case "OPEN_ABOUT_TIME_TRACKER":
        return Object.assign({}, state, _allWindowsClosedState, {
            isAboutTimeTrackerOpen: true
        });

    case "OPEN_REPORT_ERROR":
        return Object.assign({}, state, _allWindowsClosedState, {
            isReportErrorOpen: true
        });

    case "CLOSE_ALL":
        return Object.assign({}, state, _allWindowsClosedState);

    case "SHOW_LOCATIONS_FROM":
        return {
            ...state,
            isLocationListOpen: true,
            locationsFrom: action.account
        };

    case "CLOSE_LOCATIONS":
        return {
            ...state,
            isLocationListOpen: false
        };

    case "SHOW_OPPORTUNITIES_FOR":
        return {
            ...state,
            isOpportunityListOpen: true,
            opportunitiesFor: action.account
        };

    case "CLOSE_OPPORTUNITIES":
        return {
            ...state,
            isOpportunityListOpen: false
        };

    case "OPEN_DATE_FILTER_PICKER":
        return {
            ...state,
            isDateFilterPickerOpen: true
        };

    default :
        return state;
    }
}



// WEBPACK FOOTER //
// ./app/reducers/modalReducer.js